export function hasEventId(item) {
    return (item === null || item === void 0 ? void 0 : item.eventId) !== undefined;
}
//# sourceMappingURL=hasEventId.js.map